import MainIcons from '@/icons/main';
import React from 'react';
import styles from './styles.module.css';

export default function MobilePrefix() {
  return (
    <div className={`${styles.container}`}>
      <MainIcons.phoneIcon />
      <span className={`${styles.phonePrefix}`}>98+</span>
    </div>
  );
}
